import reducer from './reducers';
import * as fillAnalysesActions from './actions';
import * as fillAnalysesSelectors from './selectors';

export { fillAnalysesActions, fillAnalysesSelectors };
export default reducer;
